import Undo16 from '@carbon/icons-react/es/undo/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as EmptyTimesheetImage } from 'assets/svgs/unauthorized-timesheet.svg';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';

interface Props {
  goToApprovals: () => void;
  className?: string;
}
export const UnauthorizedState: FC<Props> = ({ goToApprovals, className }) => (
  <EmptyStateContainer className={className}>
    <EmptyState
      image={<EmptyTimesheetImage />}
      title={<FormattedMessage id="timesheets.states.unauthorized.title" />}
      message={
        <FormattedMessage id="timesheets.states.unauthorized.description" />
      }
      primaryCTA={
        <EmptyState.CallToAction.Primary
          onClick={goToApprovals}
          icon={<Undo16 />}
        >
          <FormattedMessage id="timesheets.buttons.go_to_approvals" />
        </EmptyState.CallToAction.Primary>
      }
    />
  </EmptyStateContainer>
);
